import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";

import { $kubeContexts } from "../../internal/_interop/kubernetes";

export const useKubeContexts = () => {
	const contextsAtom = $kubeContexts(undefined);
	const contextsLoadable = useAtomValue(loadable(contextsAtom));
	const contexts = contextsLoadable.state === "hasData" ? contextsLoadable.data : [];
	const refresh = useSetAtom(contextsAtom);

	return {
		contexts,
		isLoading: contextsLoadable.state === "loading",
		error: contextsLoadable.state === "hasError" ? (contextsLoadable.error as Error) : null,
		refresh,
	};
};
